import FacebookIcon from "@src/app/assets/icons/facebook.svg?react";
import InstagramIcon from "@src/app/assets/icons/instagram.svg?react";
import LinkedinIcon from "@src/app/assets/icons/linkedin.svg?react";
import TiktokIcon from "@src/app/assets/icons/tiktok.svg?react";
import XIcon from "@src/app/assets/icons/x.svg?react";
import YoutubeIcon from "@src/app/assets/icons/youtube.svg?react";
import clsx from "clsx";

import Link from "../Link";

type SocialIconsProps = {
  className?: string;
};

export default function SocialIcons({ className }: SocialIconsProps) {
  const socialLinks = [
    {
      icon: XIcon,
      href: "https://twitter.com/thinkchina",
      label: "X (Twitter)",
    },
    {
      icon: InstagramIcon,
      href: "https://instagram.com/thinkchina",
      label: "Instagram",
    },
    {
      icon: YoutubeIcon,
      href: "https://youtube.com/thinkchina",
      label: "YouTube",
    },
    {
      icon: TiktokIcon,
      href: "https://tiktok.com/@thinkchina",
      label: "TikTok",
    },
    {
      icon: FacebookIcon,
      href: "https://facebook.com/thinkchina",
      label: "Facebook",
    },
    {
      icon: LinkedinIcon,
      href: "https://linkedin.com/company/thinkchina",
      label: "LinkedIn",
    },
  ];

  return (
    <div data-testid="social-icons" className={clsx("flex gap-3", className)}>
      {socialLinks.map((social) => (
        <Link
          key={social.href}
          to={social.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.label}
          className="text-primary hover:bg-button-ghost-hover dark:text-primary-on-dark dark:hover:bg-button-ghost-hover-on-dark flex size-8 items-center justify-center rounded-full transition-colors"
        >
          <social.icon />
        </Link>
      ))}
    </div>
  );
}
